import {
  ADD_NOTE_TEMPLATES,
  FETCHING_NOTE_TEMPLATES,
  FETCHED_NOTE_TEMPLATES,
  CLEAR_ALL,
} from '../constants';

export interface NoteTemplate {
  id: number;
  account_id: number | null;
  project_id: number | null;
  name: string;
  description: string | null;
  icon: string | null;
  color: string | null;
  category: string | null;
  schema: any;
  body_template: string | null;
  summary_prompt: string | null;
  is_system: boolean;
  version: number;
  status: 'active' | 'inactive';
  created_at?: string;
  updated_at?: string;
}

export interface NoteTemplatesState {
  list: Record<string, NoteTemplate[]>;
  fetching: boolean;
  fetched: Record<string, number>;
}

const initialState: NoteTemplatesState = {
  list: {},
  fetching: false,
  fetched: {},
};

/**
 * scope_key = `${account_id}:${project_id | 'account'}`.
 * Same shape as web so both clients reason about templates identically.
 */
export default function noteTemplatesReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): NoteTemplatesState {
  switch (type) {
    case CLEAR_ALL:
      return initialState;
    case ADD_NOTE_TEMPLATES:
      return {
        ...state,
        list: { ...state.list, [payload.scope_key]: payload.list },
      };
    case FETCHING_NOTE_TEMPLATES:
      return { ...state, fetching: !!payload };
    case FETCHED_NOTE_TEMPLATES:
      return {
        ...state,
        fetched: { ...state.fetched, [payload.scope_key]: Date.now() },
      };
    default:
      return state;
  }
}
